export enum PaymentTypesEnum {
  initialFee = 'INITIAL_FEE',
  baseRepayment = 'BASE_REPAYMENT',
}
